import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import NetworkDeviceContentSelectedTable from "./NetworkDeviceContentSelectedTable";
import {connect} from "react-redux";
import {modalActions} from "../../../../actions/modal.actions";
import NetworkDeviceContentAddItemLauncherForm from "../_forms/NetworkDeviceContentAddItemLauncherForm";
import { v4 as uuidv4 } from 'uuid';

class NetworkDeviceContentLauncher extends Component {

    state = {
        selectedItem: []
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.selectedItem !== null && prevState.selectedItem?.launcherParams !== this.state.selectedItem?.launcherParams) {
            const findEl = this.props.launcherItems.find(item => item._id === this.state.selectedItem._id);
            findEl.launcherParams = this.state.selectedItem.launcherParams;
        }
    }

    handleSelected = (data) => {
        data !== null ?
            this.setState({...this.state, selectedItem: data }):
            this.setState({...this.state, selectedItem: null});
    };

    handleAddItemModal = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add-launcher-item'),
            component: <NetworkDeviceContentAddItemLauncherForm
                networkDeviceId={this.props.networkDeviceId}
                selectedItems={[...this.props.launcherItems]}
                submit={(data) => this.handleSaveSelectedItem(data)}
            />
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}));
    };

    handleSaveSelectedItem = (data) => {
        const { dispatch } = this.props;
        data.forEach((item) => {
            item._id = uuidv4()
        });
        dispatch(modalActions.hideModal());
        this.props.setLauncherItems([...this.props.launcherItems, ...data]);
    };

    handleDeleteItem = (data) => {
        console.log("NETWORK DEVICE CONTENT LAUCHER")
        console.log(data);
        console.log(this.props.launcherItems)
        const { dispatch } = this.props;
        dispatch(modalActions.hideModal());

       this.props.edit?
            this.props.setLauncherItems(this.props.launcherItems.filter((item, i) => item.id !== data.id)) :
            this.props.setLauncherItems(this.props.launcherItems.filter((item, i) => item._id !== data._id));
    }

    render() {
        const { t, launcherItems, show } = this.props;

        return (
            !show || (
                <div className="card col-md-12">
                    <div className="card-header">
                        <p className="card-title">
                            { t('launcher-content-list') }
                        </p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <Button
                                    type={"button"}
                                    variant={"primary"}
                                    size={"sm"}
                                    onClick={(e) =>this.handleAddItemModal(e)}
                                >
                                    <i className="fas fa-plus-circle"/> &nbsp;
                                    { t('add-item') }
                                </Button>
                                <NetworkDeviceContentSelectedTable list={launcherItems} getSelected={this.handleSelected} deleteItem={this.handleDeleteItem} />
                            </div>
                        </div>
                    </div>
                </div>
            )
        )
    }
}
const mapStateToProps = (state) => {
    return state;
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentLauncher));
